import { SubscriptionManager } from "../subscriptions";
export class DocumentPricingRepository {
    subscriptionMgr = new SubscriptionManager();
    subscribeToLatestPricing(documentUid, onChange) {
        return this.subscriptionMgr.addSubscription(documentUid, onChange);
    }
    notifyPricingChangeListeners(documentUid, latestPricingData) {
        this.subscriptionMgr.notify(documentUid, latestPricingData);
    }
}
//# sourceMappingURL=DocumentPricingRepository.js.map